import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import appSettings from '../../app-settings';
import { getAllTimeRange, NO_COMPARISON_RANGE, sortDataWithDirection } from '../../core/utils';
import { sortDirections } from '../../core/constants';

const DONATIONS_URL = `${appSettings.baseUrl}/donations`;

const SET_ERROR = 'dashboard/SET_ERROR';
const SET_SUCCESS = 'dashboard/SET_SUCCESS';
const GET_DONATIONS_DATA = 'dashboard/GET_DONATIONS_DATA';
const SET_ACTIVE_CHART = 'dashboard/SET_ACTIVE_CHART';
const SET_CAMPAIGN_ID = 'dashboard/SET_CAMPAIGN_ID';
const SET_DATE_RANGE = 'dashboard/SET_DATE_RANGE';
const SET_COMPARISON_DATE_RANGE = 'dashboard/SET_COMPARISON_DATE_RANGE';

export const setError = createAction(SET_ERROR);

export const setSuccess = createAction(SET_SUCCESS);

export const getDonationsData = createAsyncThunk(GET_DONATIONS_DATA, async () => {
  const res = await axios.get(`${DONATIONS_URL}?dashboard=true`);
  const orderedData = sortDataWithDirection(res.data ?? [], 'createdAt', sortDirections.desc);
  return orderedData;
});

export const setActiveChart = createAction(SET_ACTIVE_CHART);

export const setCampaignId = createAction(SET_CAMPAIGN_ID);

export const setDateRange = createAction(SET_DATE_RANGE);

export const setComparisonDateRange = createAction(SET_COMPARISON_DATE_RANGE);

// Restores the dashboard's default range ('All Time') whenever the campaign
// filter changes. Selecting a campaign narrows *which* donations are counted, not
// the window they are counted over, so the range stays in sync with the label the
// date range picker is showing.
export const resetDateRange = () => (dispatch, getState) => {
  const {
    account: { account },
  } = getState();

  const { startDate, endDate } = getAllTimeRange(account);

  dispatch(setDateRange({ startDate, endDate }));
  dispatch(setComparisonDateRange(NO_COMPARISON_RANGE));
};

export const selectCampaignId = (campaignId) => (dispatch) => {
  dispatch(setCampaignId(campaignId));
  dispatch(resetDateRange());
};
